import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-12-09
	search(params) {
		return axios.get('/delivery-settlements?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-09
	findByTitle(params) {
		return axios.get('/delivery-settlements/find-by-title', params)
	},
	// 2020-12-09
	create(params) {
		return axios.post('/delivery-settlements', params)
	},
	// 2020-12-09
	update(id, params) {
		return axios.put('/delivery-settlements/' + id, params)
	},
	// 2020-12-09
	delete(id) {
		return axios.delete('/delivery-settlements/' + id)
	},
	// 2020-12-09
	payOff(id) {
		return axios.put('/delivery-settlements/' + id + '/payoff');
	},
	// 2021-06-17
	exportExcelDetail(id, params) {
		return axios.put('/delivery-settlements/' + id + '/export-excel-detail', params)
	},
	// 2020-12-09
	findById(id) {
		return axios.get('/delivery-settlements/' + id)
	},

}